import React, { useState } from 'react'
import { Form, Modal } from 'react-bootstrap';
import { useAddNewCustomCategory } from './api';
import { queryClient } from '../../App';


const AddCustomCategoryModal = ({ show, setShow, restaurant_id }) => {
    const [enabling, setEnabling] = useState(false);
    const [categoryType, setCategoryType] = useState("menu");
    const [categoryName, setCategoryName] = useState("");
    const { mutate, isPending, isError } = useAddNewCustomCategory();

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}
            backdrop="static"
            keyboard={false}
            centered
            size="md"
        >
            <Modal.Header closeButton>
                <Modal.Title>Add New Custom Category</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    {/* ✅ Category Type Dropdown */}
                    <Form.Group className="mb-3">
                        <Form.Label>Category Type</Form.Label>
                        <Form.Select
                            value={categoryType}
                            onChange={(e) => setCategoryType(e.target.value)}
                        >
                            <option value="menu">Menu</option>
                            <option value="labor">Labor</option>
                            <option value="discount">Discount</option>
                        </Form.Select>
                    </Form.Group>

                    <Form.Label>Custom Category Name</Form.Label>
                    <Form.Control type="text" placeholder="Enter custom category name" className='mb-3'
                        value={categoryName}
                        onChange={(e) => setCategoryName(e.target.value)}
                    />




                </Form>
            </Modal.Body>
            <Modal.Footer>
                <button className="btn btn-secondary" onClick={() => {
                    setShow(false);
                    setCategoryName("")

                }}>Cancel</button>
                <button
                    className="btn btn-success"
                    onClick={() => {
                        setEnabling(true);
                        mutate({ restaurant_id, categories: [{ type: categoryType, title: categoryName, chidren: [] }] }, {
                            onSuccess: () => {
                                setEnabling(false);
                                queryClient.invalidateQueries({ queryKey: ["restaurant-category-detail"] });
setCategoryName("");
                                setShow(false);

                            },
                            onError: () => {
                                setEnabling(false);

                            }
                        })

                    }}
                >
                    {enabling ? "Adding..." : "Add"}
                </button>
            </Modal.Footer>
        </Modal>
    )
}

export default AddCustomCategoryModal